import {  AltWizActionTypeEnum } from "components/OptionsWizard/enum";
import { ISubLineItemInfo } from "components/OptionsWizard/interfaces";
import useWizardState from "components/OptionsWizard/WebDesigner/useWizardState";
import { ILineItemSimple } from "components/OptionsWizard/WizardAPI";
import { nullish, WizardModeEnum } from "components/OptionsWizard/WizardContext";
import WizardHelper from "components/OptionsWizard/WizardHelper";
import Format from "helpers/fv.format";
import useIsMobile from "helpers/hooks/useIsMobile";
import { useTranslations } from "@fenetech/translations";
import React from "react";

export default function useWizardHeaderText(odkey:number, simpleLineItem: ILineItemSimple | null): string[] {

    const wizardState = useWizardState();
    const tm = useTranslations();
    const isMobile = useIsMobile();

    const pageHeader = React.useMemo<string[]>(() => {

        if (wizardState.wizardMode === WizardModeEnum.SequencedWizard && wizardState.sequencedWizardInfo && wizardState.itemInfo && wizardState.webDesigner) {

            const altWiz = wizardState.sequencedWizardInfo;
            const itemInfo = wizardState.itemInfo;
            const webDesigner = wizardState.webDesigner;

            const sectionTitles: string[] = [];

            if (altWiz.selectedItems.length === 1) {
                sectionTitles.push(`${tm.Get("Section")} ${Format.FormatSubLineItem(altWiz.selectedItems[0])}`);
            } else if (altWiz.selectedItems.length > 1) {
                sectionTitles.push(`${tm.Get("Sections")} ${altWiz.selectedItems.map(n => Format.FormatSubLineItem(n)).sort().join(", ")}`);
            }

            const orderTitles: string[] = [itemInfo.orderNumber];

            if (itemInfo.odkey > 0) {
                orderTitles.push(itemInfo.lineItem.toString());
            }

            const partTitles: string[] = [];
            let sliInfo: ISubLineItemInfo | nullish;

            switch (altWiz.currentAction) {

                case AltWizActionTypeEnum.MainLineItemOptions:
                    partTitles.push(Format.FormatPartDescription(itemInfo.partNo, itemInfo.partNoSuffix));
                    return [...orderTitles, ...partTitles, tm.Get("Main Options")];

                case AltWizActionTypeEnum.SectionSizing:
                    sliInfo = webDesigner.sectionList?.find(sli => sli.sli === altWiz.selectedItems[0]);
                    if (sliInfo) {
                        partTitles.push(Format.FormatPartDescription(sliInfo.partNo, sliInfo.partNoSuffix));
                    }
                    return [...orderTitles, ...sectionTitles, ...partTitles, tm.Get("Section Sizing")];

                case AltWizActionTypeEnum.SectionOptions:
                    sliInfo = webDesigner.sectionList?.find(sli => sli.sli === altWiz.selectedItems[0]);
                    if (sliInfo) {
                        partTitles.push(Format.FormatPartDescription(sliInfo.partNo, sliInfo.partNoSuffix));
                    }
                    return [...orderTitles, ...sectionTitles, ...partTitles, tm.Get("Section Options")];

                case AltWizActionTypeEnum.SectionSelectPart:
                    return [...orderTitles, ...sectionTitles, tm.Get("Section Part")];
            }

            return sectionTitles;

        } else {
            if (simpleLineItem) {
                return WizardHelper.GetPageHeader(tm, odkey, simpleLineItem.partNo, simpleLineItem.partNoSuffix, simpleLineItem.orderNumber, simpleLineItem.lineItem, isMobile);
            } else {
                return [];
            }
        }

    }, [odkey, simpleLineItem, tm, isMobile, wizardState.itemInfo, wizardState.wizardMode, wizardState.sequencedWizardInfo, wizardState.webDesigner]);

    return pageHeader;

}
